var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasImage)?_c('div',{staticClass:"image-segment"},[_c('image-display',{attrs:{"image":_vm.image,"controls":_vm.segmentData.controls}}),_vm._v(" "),(_vm.image.show_caption)?_c('p',{staticClass:"image-segment__caption"},[_vm._v(_vm._s(_vm.image.caption))]):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }